import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { OrganizationMember } from "@/lib/api/betterAuth";
import { PermissionsEditor } from "./PermissionsEditor";

interface PermissionsModalProps {
  open: boolean;
  onClose: () => void;
  member?: OrganizationMember;
  organizationId?: string;
  // When provided, restricts the editor to these permission types. Other types are hidden.
  allowedPermissionTypes?: ReadonlyArray<string>;
}

export function PermissionsModal({
  open,
  onClose,
  member,
  organizationId,
  allowedPermissionTypes,
}: PermissionsModalProps) {
  if (!member || !organizationId) return null;

  return (
    <Dialog open={open} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-4xl max-h-[85vh] overflow-hidden flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>
            Manage Permissions
          </DialogTitle>
          <p className="text-sm text-gray-600">
            {member.authuser?.name || "Unknown User"}
          </p>
          <p className="text-sm text-gray-600">
            {member.authuser?.phoneNumber || "No phone number"}
          </p>
        </DialogHeader>

        <div className="flex-1 overflow-hidden mt-4">
          <PermissionsEditor
            member={member}
            organizationId={organizationId}
            onSuccess={onClose}
            inline={false}
            allowedPermissionTypes={allowedPermissionTypes}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}